<template>
	<el-dialog class="custom-dialog tsodo-detail-dialog" append-to-body destroy-on-close :visible.sync="isPopupActiveLocal">
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">TÌM KIẾM</h4>
		</div>
		<div ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" v-if="isPopupActiveLocal">

				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Từ ngày:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
				</div>

				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Tới ngày:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
				</div>

				<div class="mb-5" >
					<label for class="text-base vs-input--label"> Trạng thái thanh toán: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn Trạng thái`"
						v-model="billing_status"
						name="billing_status"
						:options="billing_statuses"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Trạng thái'"
					/>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Nhà cung cấp: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn nhà cung cấp`"
						v-model="supplier"
						name="supplier"
						:options="$store.state.moduleProduct.suppliers"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Nhà cung cấp'"
						v-validate="'required'"
						required="true"
					/>
				</div>
			</div>
		</div>

		<div class="flex justify-center" slot="footer" vs-justify="center">
			<vs-button class="vs-component vs-button font-bold" style="margin-right: 10px;" @click.stop="seekingDataLocal(true)">Xóa lọc</vs-button>
			<vs-button class="vs-component vs-button font-bold" @click.stop="seekingDataLocal(false)">Áp dụng</vs-button>
		</div>
	</el-dialog>
</template>
<script>
// import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import Helpers from '../../../utils/helpers';

export default {
	name: "DialogFilters",
	components: { vSelect, SelectAssigned, CbsDatePicker },
	props: {
		seekingData: {
			type: Function,
			required: true
		},
		cachedCustomers: {
			type: Array,
		},
		isPopupActive: {
			type: Boolean,
			required: true
		},
		state: {

		},
	},
	data() {
		return {
			supplier: null,
			settings: {},
			pickerOptions: {},
			from_date: null,
			to_date: null,
			billing_statuses: [
				{id: 0, name: 'Đang chờ'},
				{id: 1, name: 'TT một phần'},
				{id: 2, name: 'Đã thanh toán'}
			],
			billing_status: null
		};
	},
	methods: {
		seekingDataLocal(reset = false) {
			let filters = {};
			if (reset) {
				this.to_date = null;
				this.from_date = null;
				this.billing_status = null;
				this.supplier = null;
			}
			let bb = [];
			if (this.billing_status != null) {
				bb = [this.billing_status];
			}
			filters = {
				from_date: this.from_date,
				to_date: this.to_date,
				billing_statuses: bb,
				supplier: this.supplier
			};
			let state = {
				from_date: this.from_date,
				to_date: this.to_date,
				billing_statuses: bb,
				supplier: this.supplier
			};
			this.seekingData(filters, state);
		},
	},
	watch: {
		// city() {
		// 	// this.district = null;
		// 	// this.customer = null;
		// 	this.getDistrictList();
		// 	this.getCustomers();
		// 	this.setCityName()
		// },
		// district() {
		// 	// this.customer = null;
		// 	this.getCustomers();
		// 	this.setDistrictName();
		// },
		// customer() {
		// 	this.setCustomerName();
		// }
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
	},
	created() {
		const {from_date, to_date} = this.state || {};
		this.from_date = from_date;
		this.to_date = to_date;
	}
	
};
</script>
